var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.844821 7.86719C0.490269 7.86719 0.283384 8.26726 0.488321 8.55658L3.35693 12.6064C3.53104 12.8522 3.89582 12.8522 4.06993 12.6064L6.93853 8.55658C7.14347 8.26726 6.93658 7.86719 6.58203 7.86719H0.844821Z",
    fill: "#2D2C2C",
    stroke: "#236DFF",
    strokeWidth: 0.262124,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.58096 5.24219C6.93551 5.24219 7.1424 4.84212 6.93746 4.55279L4.06885 0.502996C3.89474 0.257193 3.52997 0.257193 3.35585 0.502996L0.487248 4.55279C0.282311 4.84212 0.489196 5.24219 0.843748 5.24219H6.58096Z",
    fill: "#236DFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterUp);
export default __webpack_public_path__ + "static/media/filterUp.2e4efcd288477555ecadf2b48a1c206c.svg";
export { ForwardRef as ReactComponent };